export default `
// STEP 1 - Enter the form ID:
const formId = '';

// STEP 2 - Enter the field name:
const fieldName = '';

function callback(formValue) {
    // STEP 3 - Enter custom code here:
    // console.log('form value:', formValue);
}



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



const form = document.getElementById(formId);

if (form) {
    const field = form.elements[fieldName];

    if (field) {
        const value = field.type === 'checkbox'
            ? field.checked
            : field.value;

        callback(value);
    }
}
`;
